export default class StoreSetMenuGroupModel {
  groupCode;
  name;

  constructor(data) {
    Object.assign(this, data);
  }
}
